// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./LabelTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS */

.Label-module__ContainerSmall__sgLXg {
    display: inline-flex;
    gap: var(--ds-xs);
    align-items: center;
    padding: var(--ds-xs) var(--ds-s);
    border-radius: var(--ds-border-radius-s);
}

.Label-module__ContainerMedium__AE4qE {
    display: inline-flex;
    gap: var(--ds-xs);
    align-items: center;
    padding: var(--ds-xs) var(--ds-s);
    border-radius: var(--ds-border-radius-s);
}

.Label-module__ContainerBig__TaKqY {
    display: inline-flex;
    gap: var(--ds-s);
    align-items: center;
    padding: var(--ds-s) var(--ds-sm);
    border-radius: var(--ds-border-radius-s);
}

.Label-module__Truncatable__JihIs {
    max-width: 100%;
    overflow: hidden;
}

.Label-module__Static0__sj0iK {
    color: var(--ds-label-static-0-color);
    background: var(--ds-label-static-0-bg-color);
}

.Label-module__Static1__kdNPQ {
    color: var(--ds-label-static-1-color);
    background: var(--ds-label-static-1-bg-color);
}

.Label-module__Static2__iDLLz {
    color: var(--ds-label-static-2-color);
    background: var(--ds-label-static-2-bg-color);
}

.Label-module__Static3__Tvzn6 {
    color: var(--ds-label-static-3-color);
    background: var(--ds-label-static-1-bg-color);
}

.Label-module__Static4__CjERE {
    color: var(--ds-label-static-4-color);
    background: var(--ds-label-static-1-bg-color);
}

.Label-module__Static5__JSLMb {
    color: var(--ds-label-static-5-color);
    background: var(--ds-label-static-1-bg-color);
}

.Label-module__Static6__JQ6nX {
    color: var(--ds-label-static-6-color);
    background: var(--ds-label-static-6-bg-color);
}

.Label-module__StaticInfo__HRizs {
    color: var(--ds-color-informative);
    background: var(--ds-color-informative-bg);
}

.Label-module__StaticError__teIvi {
    color: var(--ds-color-negative);
    background: var(--ds-color-negative-bg);
}

.Label-module__StaticAlert__umm7Q {
    color: var(--ds-color-alert);
    background: var(--ds-color-alert-bg);
}

.Label-module__StaticSuccess__V0vaZ {
    color: var(--ds-color-positive);
    background: var(--ds-color-positive-bg);
}

.Label-module__Dynamic__zrPNY {
    background: var(--ds-label-dynamic-bg-color);
}

.Label-module__LabelMedium__lRrBQ {
    line-height: var(--ds-m);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ContainerSmall": `Label-module__ContainerSmall__sgLXg`,
	"ContainerMedium": `Label-module__ContainerMedium__AE4qE`,
	"ContainerBig": `Label-module__ContainerBig__TaKqY`,
	"Truncatable": `Label-module__Truncatable__JihIs`,
	"Static0": `Label-module__Static0__sj0iK`,
	"Static1": `Label-module__Static1__kdNPQ`,
	"Static2": `Label-module__Static2__iDLLz`,
	"Static3": `Label-module__Static3__Tvzn6`,
	"Static4": `Label-module__Static4__CjERE`,
	"Static5": `Label-module__Static5__JSLMb`,
	"Static6": `Label-module__Static6__JQ6nX`,
	"StaticInfo": `Label-module__StaticInfo__HRizs`,
	"StaticError": `Label-module__StaticError__teIvi`,
	"StaticAlert": `Label-module__StaticAlert__umm7Q`,
	"StaticSuccess": `Label-module__StaticSuccess__V0vaZ`,
	"Dynamic": `Label-module__Dynamic__zrPNY`,
	"LabelMedium": `Label-module__LabelMedium__lRrBQ`
};
export default ___CSS_LOADER_EXPORT___;
